import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type Employee} from './model';

const domain = 'ENTITIES/EMPLOYEES';

export const {
    action: fetchEmployee,
    success: fetchEmployeeSuccess,
    failed: fetchEmployeeFailed,
} = createAction(
    `${domain}/FETCH`,
    (employeeId: string) => ({employeeId}),
    (employee: Employee) => ({employee}),
);

export const {
    action: fetchAllEmployees,
    success: fetchAllEmployeesSuccess,
    failed: fetchAllEmployeesFailed,
} = createAction(`${domain}/FETCH_ALL`, (institutionId: string) => ({institutionId}));

export const {
    action: createEmployee,
    success: createEmployeeSuccess,
    failed: createEmployeeFailed,
} = createAction(
    `${domain}/CREATE_EMPLOYEE`,
    (institutionId: string, name: string, email: string | undefined, groupId: string) => ({
        institutionId,
        name,
        email,
        groupId,
    }),
    (payload: {employee: Employee}) => payload,
);

export const {
    action: updateGroup,
    success: updateGroupSuccess,
    failed: updateGroupFailed,
} = createAction(
    `${domain}/UPDATE_EMPLOYEE_GROUP`,
    (employeeId: string, groupId: string) => ({employeeId, groupId}),
    (payload: {employee: Employee}) => payload,
    (payload: {employeeId: string; e: Error}) => payload,
);

export const {
    action: updateKeyChildren,
    success: updateKeyChildrenSuccess,
    failed: updateKeyChildrenFailed,
} = createAction(
    `${domain}/UPDATE_KEY_CHILDREN`,
    (employeeId: string, keyChildren: any) => ({employeeId, keyChildren}),
    (employeeId: string, keyChildren: any) => ({employeeId, keyChildren}),
);
